<template>
  <div class="container">
<!--    <img-->
<!--      class="challenge-image"-->
<!--      src="~/assets/images/SampleMeterLeaderChallenge.webp"-->
<!--    />-->
    <h3 class="pb-2">{{challenge.name}}</h3>
    <div class="challenge-stats d-flex justify-content-around">
      <div class="text-center">
        <div>👤</div>
        <div class="font-weight-bold">
          {{ challenge.current_participants }}
        </div>
        <div><p class="vs-text grey-text">Participants</p></div>
      </div>
      <div class="text-center">
        <div>⚡</div>
        <div class="font-weight-bold">{{ Math.ceil(challenge.savings_kwh) || '-' }}</div>
        <div><p class="vs-text grey-text">Electricity (kWh)</p></div>
      </div>
      <div class="text-center">
        <div>🔥</div>
        <div class="font-weight-bold">{{ Math.ceil(challenge.savings_thm) || '-' }}</div>
        <div><p class="vs-text grey-text">Gas (therm)</p></div>
      </div>
      <div class="text-center">
        <div>💨</div>
        <div class="font-weight-bold">{{ Math.ceil(challenge.savings_co2) || '-' }}</div>
        <div><p class="vs-text grey-text">CO2 (lbs)</p></div>
      </div>
      <div class="text-center">
        <div>
          <p class="c-information" @click="toggleInformation">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="20" height="20"
                 viewBox="0 0 26 26">
              <path d="M 13 1.1875 C 6.476563 1.1875 1.1875 6.476563 1.1875 13 C 1.1875 19.523438 6.476563 24.8125 13 24.8125 C 19.523438 24.8125 24.8125 19.523438 24.8125 13 C 24.8125 6.476563 19.523438 1.1875 13 1.1875 Z M 15.460938 19.496094 C 14.851563 19.734375 14.367188 19.917969 14.003906 20.042969 C 13.640625 20.167969 13.222656 20.230469 12.742188 20.230469 C 12.007813 20.230469 11.433594 20.050781 11.023438 19.691406 C 10.617188 19.335938 10.414063 18.878906 10.414063 18.324219 C 10.414063 18.109375 10.429688 17.890625 10.460938 17.667969 C 10.488281 17.441406 10.539063 17.191406 10.605469 16.90625 L 11.367188 14.21875 C 11.433594 13.960938 11.492188 13.71875 11.539063 13.488281 C 11.585938 13.257813 11.605469 13.046875 11.605469 12.855469 C 11.605469 12.515625 11.535156 12.273438 11.394531 12.140625 C 11.25 12.003906 10.980469 11.9375 10.582031 11.9375 C 10.386719 11.9375 10.183594 11.96875 9.976563 12.027344 C 9.769531 12.089844 9.59375 12.148438 9.445313 12.203125 L 9.648438 11.375 C 10.144531 11.171875 10.621094 11 11.078125 10.855469 C 11.53125 10.710938 11.964844 10.636719 12.367188 10.636719 C 13.097656 10.636719 13.664063 10.816406 14.058594 11.167969 C 14.453125 11.519531 14.652344 11.980469 14.652344 12.542969 C 14.652344 12.660156 14.640625 12.867188 14.613281 13.160156 C 14.585938 13.453125 14.535156 13.722656 14.460938 13.972656 L 13.703125 16.652344 C 13.640625 16.867188 13.585938 17.113281 13.535156 17.386719 C 13.488281 17.660156 13.464844 17.871094 13.464844 18.011719 C 13.464844 18.367188 13.542969 18.613281 13.703125 18.742188 C 13.859375 18.871094 14.136719 18.933594 14.53125 18.933594 C 14.714844 18.933594 14.921875 18.902344 15.15625 18.839844 C 15.386719 18.773438 15.554688 18.71875 15.660156 18.667969 Z M 15.324219 8.617188 C 14.972656 8.945313 14.546875 9.109375 14.050781 9.109375 C 13.554688 9.109375 13.125 8.945313 12.769531 8.617188 C 12.414063 8.289063 12.238281 7.890625 12.238281 7.425781 C 12.238281 6.960938 12.417969 6.558594 12.769531 6.226563 C 13.125 5.894531 13.554688 5.730469 14.050781 5.730469 C 14.546875 5.730469 14.972656 5.894531 15.324219 6.226563 C 15.679688 6.558594 15.855469 6.960938 15.855469 7.425781 C 15.855469 7.890625 15.679688 8.289063 15.324219 8.617188 Z"></path>
            </svg>
          </p>
        </div>
      </div>
    </div>
    <div class="mx-3" :class="i_icon">
      <p :style="{ fontSize: '0.72rem' }">
        *Data will be displayed once there are at least 5 eligible
        participants. <a class="link" href="#">Learn More</a>
      </p>
    </div>
    <div class="challenge-actions">
      <div class="d-flex">
        <div>
          <p class="mb-1 font-weight-bold pl-2">
            {{ Math.round(challenge.savings_co2 || 0) }}
            <span><small class="font-weight-leight">lbs</small></span>
          </p>
        </div>
        <div class="flex-grow-1"></div>
        <div>
          <p class="mb-1 font-weight-light pr-2">
            {{
              Math.round((Math.round(challenge.savings_co2 || 0) * 100) /
              challenge.savings_goal)
            }}% of {{ challenge.savings_goal }} lbs CO<sub>2</sub> goal
          </p>
        </div>
      </div>
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          :style="`width: ${
            (Math.round(challenge.savings_co2 || 0) * 100) /
            challenge.savings_goal
          }%`"
          aria-valuenow="50"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div class="">
        <button
          v-if="!isUserInChallenge"
          @click="joinClick"
          class="join-challenge-btn"
        >
          Join Challenge
        </button>
        <button
          v-else-if="$auth.loggedIn"
          data-toggle="modal"
          data-target="#leaveModal"
          class="join-challenge-btn participating-btn"
        >
          <img src="~/assets/images/whiteCheckmark.png"> <span class="participating">Participating</span>
        </button>
<!--        <button><img class="c-share-btn" src="~/assets/images/greenShare.png"></button>-->
      </div>
<!--      <div class="d-flex justify-content-around">-->
<!--        <button class="share-btn">Copy Link</button>-->
<!--        <button class="share-btn">Share</button>-->
<!--      </div>-->
    </div>
    <div class="d-flex ctabs">
      <div
        class="ctab-item font-weight-bold"
        :class="{ selected: selectedTab == 'Leaderboard' }"
        @click="selectedTab = 'Leaderboard'"
      >
        LeaderBoard
      </div>
      <div
        class="ctab-item font-weight-bold"
        :class="{ selected: selectedTab == 'ChallengeDetail' }"
        @click="selectedTab = 'ChallengeDetail'"
      >
        Detail
      </div>
    </div>

    <div class="challenge-details" v-if="selectedTab == 'ChallengeDetail'">
      <div class="d-flex align-items-center">
        <h3>Details</h3>
        <div :style="{ flexGrow: 1 }"></div>
        <button class="rules-btn" @click="$router.push('/challenges/rules/'+challenge.id)">
          <font-awesome-icon class="pr-2" icon="scroll" size="sm" />Rules
        </button>
      </div>
      <div class="mt-4">
        <b>Starts:</b> {{ startDate }}
      </div>
      <div class="mb-4">
        <b>Ends:</b> {{ endDate }}
      </div>
      <div>{{ timeLeft }}</div>

      <div class="mb-4">
        {{ challenge.description }}
      </div>
      <div class="organizer d-flex">
        <img class="avatar mt-3" :src="challenge.image_creator_url" />
        <div class="ml-3">
          <small class="font-weight-bold primary-text">Organizer</small>
          <p class="font-weight-bold mb-0">{{ challenge.sponsor_name }}</p>
          <small class="grey-text"
            >Created on {{ challenge.created_dtm | formatDateOnly }}</small
          >
          <br />
          <br />
          <u
            ><a
              v-if="challenge.sponsor_website"
              :href="makeUrl(challenge.sponsor_website)"
              class="link"
              >Link 1</a
            ></u
          >
          <br />
          <u
            ><a
              v-if="challenge.sponsor_facebook"
              :href="makeUrl(challenge.sponsor_facebook)"
              class="link"
              >Link 2</a
            ></u
          >
          <br />
          <u
            ><a
              v-if="challenge.sponsor_twitter"
              :href="makeUrl(challenge.sponsor_twitter)"
              class="link"
              >Link 3</a
            ></u
          >
        </div>
      </div>
    </div>
    <ChallengeLeaderBoard v-if="selectedTab == 'Leaderboard'"
      :participating-teams="participatingTeams"
      :has-challenge-started="hasChallengeStarted"
      :challenge-metric="challenge.metric"
    />

    <SelectTeam
      :challenge="this.challenge"
      :showModal.sync="showTeamSelect"
      @selectedTeam="($event) => selectedTeamPromiseResolve($event)"
      @showRules="showRules"
    />
    <SelectParticipantGroup
      :showModal.sync="showParticipantGroupSelect"
      :challengeId="$route.params.challenge"
      @selectedParticipantGroup="
        ($event) => selectedParticipantGroupResolve($event)
      "
    />
  </div>
</template>
<script>
import challengeMixin from '@/mixins/challenge';
import ChallengeLeaderBoard from '../NewChallengeLeaderBoard.vue';
export default {
  backButtonRoute: '/challenges',
  data() {
    return {
      selectedTab: 'Leaderboard',
      i_icon: 'd-none'
    };
  },
  mixins: [challengeMixin],
  components: {
    ChallengeLeaderBoard,
  },
  methods: {
    toggleInformation() {
      this.i_icon = this.i_icon === 'd-none' ? 'd-block' : 'd-none';
    }
  }
};
</script>
<style lang="sass" scoped>
@use "sass:color"
@import '~@/assets/css/_variables.scss'

.root
  background: color.scale($grey, $lightness: 70%)

.vs-text
  font-size: 0.7rem

.primary-text
  color: $accent

.grey-text
  color: $medium-grey

.rules-btn
  background-color: $light-grey
  padding: 5px
  border-radius: 5px

.join-challenge-btn
  padding: 15px 40px 15px 40px
  width: 100%
  font-weight: 500
  color: #fff
  background: linear-gradient(to right, $accent, $primary)
  border-radius: 50px
  margin: 10px 0px 10px 0px

.participating-btn
  width: 100%
  background: #1AD596
  padding: 5px 40px 5px 40px
  > img
    width: 11%

.share-btn
  width: 100%
  color: $accent
  padding: 5px 10px 5px 10px
  border: 1.2px solid $accent
  border-radius: 50px
  margin: 5px

.avatar
  width: 100%
  height: 40px
  width: 40px
  border-radius: 50px
  margin: 5px

.challenge-image
  height: 200px
  width: 100%
  object-fit: cover

.challenge-details
  border-radius: 10px
  background-color: #fff
  padding: 30px

.column1
  flex: 1
  margin: 10px

.column2
  flex: 1
  margin: 10px

.challenge-actions
  // padding: 30px
  background-color: #fff
  border-radius: 10px
  > .progress

    margin-bottom: 10px
    height: 27px
    border-radius: 18px
    > .progress-bar
      background-color: $accent
      border-radius: 18px

.link
  color: $primary

.challenge-stats
  //padding-top: 20px
  //padding-bottom: 20px

.leaderboard
  margin-top: 15px
  padding: 30px
  background-color: #fff
  border-radius: 10px

.ctabs
  border-radius: 18px !important
  margin-top: 1rem !important
  padding: 4px
  background-color: $grey

.ctab-item
  width: 100%
  border-radius: 18px !important
  text-align: center
  &.selected
    background-color: white

.c-share-btn
  width: 40%
  //padding-bottom: 5%

.c-information
  cursor: pointer
  > img
    width: 10%

.participating
  font-size: 17px
</style>
